import React from 'react'
import { accordionPlugin as baseAccordionPlugin } from '@peracto/peracto-content/dist/Editor/ContentBlocks'
import AccordionRenderer from './Renderer/AccordionRenderer'

/**
 * Custom Accordion block that extends the base peracto-content accordion.
 * Uses our custom AccordionRenderer but keeps the full FormComponent from the base
 * (header colours, font size, accordion items, etc.).
 */
const BaseAccordion = baseAccordionPlugin({ isTailwind: true })

const Accordion = {
    ...BaseAccordion,
    Component: props => <AccordionRenderer {...props} />,
}

const accordionPlugin = settings =>
    settings ? { ...Accordion, ...settings } : Accordion

export default Accordion

export { accordionPlugin, AccordionRenderer }
